import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useTitleDispatch } from '@components/TitleContextProvider';
import getAction from '@behavior/activity/getAction';
import { Loading } from 'react-lib/dist/components-es';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import ActionCard from './components/actionForm/ActionCard';
import { Form, FormProvider, useForm } from 'react-hook-form';
import ButtonWrapper from '@components/common/ButtonWrapper';
import useMarkActionAsCompleted from '@behavior/activity/useMarkActionAsCompleted';
import ErrorPage from '@src/pages/ErrorPage';

type Props = {
  id: number;
};

const ActionContainer = ({ id }: Props) => {
  const { t } = useTranslation();
  const dispatch = useTitleDispatch();
  const { action, isLoading } = getAction(parseInt(id.toString()));
  const methods = useForm({ mode: 'onChange' });
  const useMarkActionAsCompletedMutate = useMarkActionAsCompleted();

  useEffect(() => {
    const pageTitle = t('page.action.title');
    dispatch({
      pageTitle,
    });
  }, [dispatch, t]);

  if (isLoading) {
    return <Loading isLoading />;
  }

  if (!action) {
    return <ErrorPage />;
  }

  const handleMarkAsCompleted = () => {
    if (action.id) {
      useMarkActionAsCompletedMutate(action.id);
    }
  };

  const isActionCompleted = action?.completionDte;

  return (
    <FormProvider {...methods}>
      <Form id="action-form">
        <div className="actionContainer">
          <ActionCard
            onRemove={() => {}}
            actionContent={action}
            setActionCardContent={() => {}}
            disabled
            index={0}
          />
          {!isActionCompleted && (
            <div className="actionMarkAsCompletedBtn">
              <ButtonWrapper
                label="action.mark.as.completed"
                primary
                icon="checkmark"
                onClick={handleMarkAsCompleted}
              />
            </div>
          )}
        </div>
      </Form>
    </FormProvider>
  );
};

const mapStateToProps = (state: any, ownProps: any) => ({
  id: ownProps.match.params.id,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(ActionContainer) as React.FC<Props>;
